{
    "IncludeendedonholdLabel": "Incluir encerrado em espera:",
    "UnreturnedCalls_SectionHeader": "Chamadas não retornadas",
    "UnreturnedCalls_SectionPara": "Você pode escolher se as chamadas encerradas em espera são consideradas como abandonadas nos relatórios \"Chamadas não retornadas perdidas\", bem como na estatística \"Chamadas não retornadas\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Incluir Fugitivo:"
}